// Voulgaris Edge 5 — CLV badge presentational. Renders ONLY when the
// honest gates pass (≥20 slips, positive CLV). Below that it returns
// null — no badge, no fabricated status (doc §13).

import type { ClvBadge as ClvBadgeModel } from "./clvBadge.ts";

export function ClvBadge({ badge }: { badge: ClvBadgeModel }): JSX.Element | null {
  if (badge.tier === null || badge.label === null) return null;
  const pro = badge.tier === "professional";
  return (
    <span
      data-testid="clv-badge"
      data-clv-tier={badge.tier}
      title="Closing Line Value — the only honest measure of whether the process is working (Voulgaris)."
      style={{
        fontFamily: "var(--sz-font-mono, monospace)",
        fontSize: 10.5,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        padding: "2px 8px",
        borderRadius: 3,
        alignSelf: "flex-start",
        color: pro
          ? "var(--sz-success-text, #1fbf75)"
          : "var(--sz-text-primary, #e8e8ea)",
        border: `1px solid ${
          pro ? "var(--sz-success, #1fbf75)" : "var(--sz-border-dim, #2a2a30)"
        }`,
      }}
    >
      {badge.label}
    </span>
  );
}
